type Collection = Record<
  string,
  {
    addedAt: number
    lastRanAt: number
    interval: number
    fn: () => void
    paused?: boolean
  }
>

class Poller {
  collection: Collection
  timeoutId?: ReturnType<typeof setTimeout>
  _latency: number
  _loopFn?: () => void

  constructor() {
    this.collection = {}
    this._latency = 100
  }

  add(name: string, interval: number, fn: () => void) {
    const date = Date.now()

    this.collection[name] = {
      addedAt: date,
      lastRanAt: date,
      interval,
      fn
    }
  }

  stop() {
    clearTimeout(this.timeoutId)
  }

  clear() {
    this.collection = {}
  }

  runFunctions() {
    const functions = this.collection
    Object.keys(functions).forEach(d => {
      if (Object.hasOwn(functions, d)) {
        const func = functions[d]
        const date = Date.now()
        const g = date - func.lastRanAt
        if (!func.paused && g >= func.interval) {
          func.lastRanAt = date
          try {
            func.fn()
          } catch {}
        }
      }
    })
  }

  start() {
    clearTimeout(this.timeoutId)

    if (!this._loopFn) {
      this._loopFn = () => {
        this.runFunctions()
        this.timeoutId = setTimeout(this._loopFn!, 100)
      }
    }

    this._loopFn()
  }

  resume(name: string) {
    const func = this.collection[name]
    func.paused = false
  }

  pause(name: string) {
    const func = this.collection[name]
    func.paused = true
  }

  delete(name: string) {
    delete this.collection[name]
  }
}

export default Poller
